import { RouteRecordRaw } from 'vue-router';

import { RouteKeys } from '~/router/routes.domain';

export const FranceConnectRoute: RouteRecordRaw = {
	name: RouteKeys.FC,
	path: '/france-connect',
	components: {
		default: () => import('~/_v3/france-connect/ui/pages/FranceConnectPage.vue')
	},
	meta: {
		public: true
	},
	props: true
};
